import { Controller } from "stimulus";
import { setFocusedStates } from "../utilities/charts/payer_profile_state_filter";

// The payer profile account manager dropdown. Grays out, on the state maps,
// the states outside the chosen manager's (or outside the unassigned ones),
// and remembers the choice per portal across payer profile pages.
export default class extends Controller {
  // states: { managers: [{ id, name, states }], unassigned: [...] }
  // (PayerProfile::AccountManagerStates)
  static values = { states: Object, storageKey: String };

  connect() {
    const saved = this.read();

    if (saved && [...this.element.options].some(option => option.value === saved)) {
      this.element.value = saved;
    }
    this.apply();
  }

  disconnect() {
    setFocusedStates(null);
  }

  change() {
    this.store(this.element.value);
    this.apply();
  }

  apply() {
    const choice = this.element.value;

    if (!choice) {
      setFocusedStates(null);
    } else if (choice === "unassigned") {
      setFocusedStates(this.statesValue.unassigned);
    } else {
      const manager = this.statesValue.managers.find(m => String(m.id) === choice);

      setFocusedStates(manager ? manager.states : null);
    }
  }

  get storageKey() {
    return `payer-profile-account-manager:${this.storageKeyValue}`;
  }

  store(choice) {
    try {
      localStorage.setItem(this.storageKey, choice);
    } catch (_) {
      // Storage blocked (e.g. private mode); the filter still works on this page
    }
  }

  read() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (_) {
      return null;
    }
  }
}
